export const BASE_URL = process.env.REACT_APP_BASE_URL
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL
